module.exports = __webpack_public_path__ + "img/10.f2a5a22.webp";